import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface TextColumnFilterContainerProps {
  children: ReactNode;
  className?: string;
}

export function InputColumnFilterContainer({
  children,
  className,
}: TextColumnFilterContainerProps) {
  return <div className={twMerge("w-[190px] py-2", className)}>{children}</div>;
}
